import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    errors: {
      emailAlreadyUsed: 'Email already used',
    },
    free: 'Free',
    labels: {
      inviteeEmail: 'Email address',
      inviteeFirstName: 'First name',
      inviteeLastName: 'Surname',
    },
    placeholders: {
      inviteeEmail: 'example@email.com',
      inviteeFirstName: 'First name',
      inviteeLastName: 'Last name',
    },
    proBusinessOnly:
      'Admin and employee access are only available on Pro and Business plans',
    sendInvitation: 'Send invitation',
    submit: 'Continue',
    title: 'Define their identity',
    titleAccountOnly: 'Invite your accountant to join your Shine account',
    upgradePlan: 'Upgrade my plan',
  },
  fr: {
    cancel: 'Annuler',
    errors: {
      emailAlreadyUsed: 'Cette adresse email déjà utilisée',
    },
    free: 'Gratuit',
    labels: {
      inviteeEmail: 'Adresse e-mail',
      inviteeFirstName: 'Prénom',
      inviteeLastName: 'Nom',
    },
    placeholders: {
      inviteeEmail: 'exemple@email.fr',
      inviteeFirstName: 'Prénom',
      inviteeLastName: 'Nom de famille',
    },
    proBusinessOnly:
      'Les accès admin et employé sont accessibles seulement sur les plans Pro et Business',
    sendInvitation: 'Envoyer l’invitation',
    submit: 'Continuer',
    title: 'Définissez son identité',
    titleAccountOnly: 'Inviter votre comptable à rejoindre votre compte Shine',
    upgradePlan: 'Mettre à niveau mon plan',
  },
} as const);

export default locales;
